import { routerErrror } from '../route-navigation'

function gameClick(item) {
  window.localStorage.setItem('game_id', item.id)
  window.localStorage.setItem('game_server', item.name)
  window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth',
  })
  this.$router
    .push({
      name: 'GiftcodeDetail',
      params: { id: item.alias },
    })
    .catch(routerErrror)
}

export { gameClick }
